<div class="backdrop" (click)="onBackdropClick()"></div>
<div class="content-container">
  <ng-content></ng-content>
</div>
